
import Box1 from "../../../assets/outline/Box1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Box1Icon({ className, dataTestid = "Box1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Box1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
